/**
 * 分割ペインの左側に表示し続ける「一覧」のパス。
 * 詳細を開いたときは、その記事が属する日に追従させる。
 */
import { useSyncExternalStore } from 'react';
import { toDateKey } from '../../lib/datetime';

const KEY = 'nj.listPath';
const listeners = new Set<() => void>();

let current = sessionStorage.getItem(KEY) ?? `/day/${toDateKey(new Date())}`;

export function setListPath(path: string): void {
  if (path === current) return;
  current = path;
  sessionStorage.setItem(KEY, path);
  listeners.forEach((l) => l());
}

export function useListPath(): string {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
}
